import theme_color from 'resources/theme/theme.colors';

import { alpha, createTheme } from '@mui/material';

const theme = createTheme({
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: theme_color.palette.secondary.main,
          boxShadow: 'none',
          disableElevation: true,
          '&:hover': {
            backgroundColor: alpha(theme_color.palette.primary.light, 0.2),
            boxShadow: 'none',
          },
        },
      },
    },
  },
});

export default theme;
